import React from 'react';
import styles from '../shared/TipComponents.module.scss';

/*Components */
import { ProductContainer } from '../../../shared/components/ProductContainer/ProductContainer';
import { TipHeader } from '../../components/TipHeader/TipHeader';
import { TipBox } from '../../components/TipBox/Box/TipBox';
import { TipCouponInfo } from '../../components/TipCouponInfo/TipCouponInfo';
import { TipAnalysisBoxConnected } from '../../components/TipAnalysisBox/TipAnalysisBox';
import { UnlockedTipBoxTopConnected } from '../../components/TipBox/Top/UnlockedTipBoxTop';

/* Interfaces */
import { PaidTipProduct, Tipster } from '../../interfaces/TipProduct';

interface PaidTipProps {
  tipster: Tipster;
  tip: PaidTipProduct;
}

export const PurchasedPaidTipComponent: React.FC<PaidTipProps> = ({
  tipster,
  tip,
}) => {
  return (
    <>
      <ProductContainer>
        <div className={styles.container}>
          <TipHeader type={tip.priceType} />

          <TipBox>
            <UnlockedTipBoxTopConnected />
          </TipBox>

          <TipCouponInfo />
        </div>
      </ProductContainer>

      <TipAnalysisBoxConnected />
    </>
  );
};
